import { Button, Grid, Typography } from "@material-ui/core";
import { useState } from "react";

import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { SearchTextField } from "@/controls/quick-filter-textfield/SearchTextField";
import { PhaseEventType } from "@/pages/eaf/data-entry/models/eaf.models";
import { useGridStyles } from "@/pages/laboratory/styles/gridStyles";
import { AgGridReact } from "ag-grid-react";
import { UpsertPhaseEvent } from "./UpsertPhaseEvent";
import { useTableData } from "./hooks";
type Props = {
	getPhaseEventsFromAPI: Function;
	isLoading: boolean;
};

export const TablePhaseEvents = ({
	getPhaseEventsFromAPI,
	isLoading,
}: Props) => {
	const classes = useGridStyles();
	const [showCreateModal, setShowCreateModal] = useState(false);
	const [showEditModal, setShowEditModal] = useState(false);
	const [phaseEvent, setPhaseEvent] = useState<PhaseEventType | null>(null);
	const [quickFilterText, setQuickFilterText] = useState("");
	const { rows, columns } = useTableData({});
	const { columnDefaults, columnTypes } = useGridDefinitions({
		OnEdit: (data: PhaseEventType) => {
			setShowEditModal(!showEditModal);
			setPhaseEvent(data);
		},
	});

	return (
		<>
			<Grid item xs={12} container justifyContent="center" spacing={1}>
				<Grid item md={12} xs={12}>
					<Typography variant="h5" style={{ fontWeight: 600 }}>
						Phase Events
					</Typography>
				</Grid>

				<Grid
					item
					xs={12}
					container
					justifyContent="flex-end"
					alignContent="center"
				>
					<Grid item xs={12} style={{ marginBottom: 10 }}>
						<SearchTextField
							value={quickFilterText}
							onChange={(text) => setQuickFilterText(text)}
							label="Search phase events"
						/>
					</Grid>
					<Grid
						item
						md={12}
						xs={12}
						style={{ height: "68vh" }}
						className={classes.borderAgGridTable}
					>
						<div style={{ height: "100%", width: "100%" }}>
							<AgGridReact
								rowData={rows || []}
								columnDefs={columns}
								getRowId={(params) => params.data.PhaseEventTypeId}
								columnTypes={columnTypes}
								suppressContextMenu
								onRowDoubleClicked={(params) => {
									setPhaseEvent(params.data);
									setShowEditModal(true);
								}}
								rowSelection="single"
								quickFilterText={quickFilterText}
							/>
						</div>
					</Grid>

					<Grid item md={"auto"} xs={12} style={{ marginTop: 10 }}>
						<Button
							variant="contained"
							color="primary"
							fullWidth
							style={{ minWidth: 250 }}
							onClick={() => setShowCreateModal(!showCreateModal)}
						>
							NEW PHASE EVENT
						</Button>
					</Grid>
				</Grid>
			</Grid>
			<UpsertPhaseEvent
				show={showCreateModal || showEditModal}
				onHide={() => {
					setShowEditModal(false);
					setShowCreateModal(false);
					setPhaseEvent(null);
					getPhaseEventsFromAPI();
				}}
				refreshData={getPhaseEventsFromAPI}
				phaseEvent={phaseEvent}
			/>
		</>
	);
};
